var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMunicipaltax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.673,
    height: 50.66,
    viewBox: "0 0 43.673 50.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-miterlimit:10;stroke-width:2px;}.a{stroke:#4f4f4f;stroke-linecap:round;}.b{stroke:#40b895;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.247,144.449H143.623a4.393,4.393,0,0,1-4.393-4.393V107.913a4.393,4.393,0,0,1,4.393-4.393h24.265a4.4,4.4,0,0,1,4.4,4.393V128.18",
    transform: "translate(-139.23 -103.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 22.1,
    height: 8.716,
    transform: "translate(5.476 6.187)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 3.094,
    transform: "translate(4.592 20.465)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 5.304,
    transform: "translate(13.211 20.465)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 5.083,
    transform: "translate(4.592 25.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M270.227,265.073a12.083,12.083,0,1,1-12.083-12.083,11.872,11.872,0,0,1,3.972.673A12.073,12.073,0,0,1,270.227,265.073Z",
    transform: "translate(-228.554 -228.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.714,289.23l-6.8,5.639.623,7.13",
    transform: "translate(-284.45 -258.799)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMunicipaltax);
export default __webpack_public_path__ + "static/media/municipaltax.747d9996e6a39696f6065d9a05cf4428.svg";
export { ForwardRef as ReactComponent };